/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import Model from 'can/model/model';
import Map from 'scripts/models/base/map';
import PlayerService from 'scripts/services/player-service';

const leaderboardLink = window.globalSettings.pagePaths.leaderboard;

export default Model.extend(
    {},
    {
        define: {
            short: {
                type: 'boolean',
                value: false,
            },
            fetching: {
                type: 'boolean',
                value: false,
            },
            standings: {
                Type: Map.List,
                Value: '*',
            },
            favorites: {
                Type: Map.List,
                Value: '*',
            },
            activeId: {
                type: 'string',
                value: '',
            },
            autoOpened: {
                type: 'boolean',
                value: false,
            },
            hasFavorite: {
                type: 'boolean',
                value: false,
            },
            leaderboardLink: {
                get() {
                    return leaderboardLink;
                },
            },
            getAnalyticsScoring: {
                get() {
                    if (this.attr('short')) {
                        return 'Live Video Mini Leader Board';
                    } else {
                        return 'Mini Leader Board';
                    }
                },
            },
        },
        getFavoritesList: () => {
            return PlayerService.getFavorites();
        },
    },
);
